/**
 * Text utility functions for formatting and highlighting
 */

import React from 'react'

/**
 * Formats a date string into "DD MMMM YYYY" format.
 * e.g., "2024-07-16T10:00:00Z" -> "16 July 2024"
 * @param dateString The date string to format
 * @returns The formatted date string
 */
export const formatToLongDate = (dateString: string | undefined): string => {
  if (!dateString) {
    return 'N/A'
  }
  try {
    const date = new Date(dateString)
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    })
  } catch (error) {
    console.error('Error formatting date:', error)
    return 'Invalid Date'
  }
}

/**
 * Highlights search terms in text using standard HTML mark elements
 * @param text The text to search within
 * @param query The search query to highlight
 * @returns React nodes with highlighted text
 */
export const highlightText = (text: string | undefined, query: string): React.ReactNode => {
  if (!text || !query || query.trim() === '') {
    return text || ''
  }

  // Escape special regex characters in the query
  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  const parts = text.split(new RegExp(`(${escapedQuery})`, 'gi'))
  
  return parts.map((part, index) => 
    part.toLowerCase() === query.toLowerCase() ? (
      <mark key={index} style={{ backgroundColor: 'yellow', fontWeight: 'bold' }}>
        {part}
      </mark>
    ) : (
      <React.Fragment key={index}>{part}</React.Fragment>
    )
  )
}
